import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  DocumentData,
  getFirestore,
  onSnapshot,
  setDoc,
  updateDoc,
} from "firebase/firestore";

import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const stripeConfig = {
  price: process.env.REACT_APP_STRIPE_PRICE_ID,
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export const create = (collectionName: string, data: DocumentData) =>
  addDoc(collection(db, collectionName), data);

export const update = (collectionName: string, docId: string, data: DocumentData) => {
  const docRef = doc(db, collectionName, docId);
  return updateDoc(docRef, data);
};

export const upsert = (collectionName: string, docId: string, data: DocumentData) => {
  const docRef = doc(db, collectionName, docId);
  return setDoc(docRef, data);
};

export const deleteByDocId = (collectionName: string, docId: string) => {
  const docRef = doc(db, collectionName, docId);
  return deleteDoc(docRef);
};

export const pay = async (movieId: string, userId: string, donate = false) => {
  const collection = `customers/${userId}/checkout_sessions`;
  const payment = await create(collection, {
    mode: "payment",
    price: stripeConfig.price,
    success_url: window.location.origin+"?merci",
    cancel_url: window.location.origin,
    metadata: {
      movie: movieId,
      donate: donate ? "DONATION" : "REIMBURSABLE",
    }
  });
  const docSnapRef = doc(db, collection, payment.id);
  onSnapshot(docSnapRef, (docSnapshot) => {
    const data = docSnapshot.data();
    if (data) {
      const { error, url } = data;

      if (error) {
        alert("Une erreur est survenue, veuillez réessayer.");
      }

      if (url) {
        window.location.assign(url);
      }
    }
  });
}

export { app, db, auth, storage };
